import { useCallback, useEffect, useState } from 'react';

import { api, type CurrentUser } from './api';

export interface Session {
  user: CurrentUser | null;
  domain: string;
  loading: boolean;
  refresh: () => Promise<void>;
  signOut: () => Promise<void>;
}

/** Текущая сессия сотрудника. Гостю она не нужна — он входит по ссылке. */
export function useSession(): Session {
  const [user, setUser] = useState<CurrentUser | null>(null);
  const [domain, setDomain] = useState('gto.group');
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const data = await api.me();
      setUser(data.user);
      setDomain(data.domain);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    let alive = true;
    api
      .me()
      .then((data) => {
        if (!alive) return;
        setUser(data.user);
        setDomain(data.domain);
      })
      .catch(() => alive && setUser(null))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, []);

  const signOut = useCallback(async () => {
    await api.logout().catch(() => {});
    setUser(null);
  }, []);

  return { user, domain, loading, refresh, signOut };
}
